import React, { useEffect, useMemo, useState } from 'react';
import { Container, Alert } from 'react-bootstrap';
import EventSearchBox from './EventSearchBox';
import { filterEvents } from './filterEvents';

function LiveTvPage() {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;

    const [replays, setReplays] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [error, setError] = useState(null);

    const visibleReplays = useMemo(
        () => filterEvents(replays, searchQuery),
        [replays, searchQuery]
    );

    useEffect(() => {
        // Fetch the NFL replays from the backend
        fetch(baseUrl + '/streaming/livetv/events')
        .then(response => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json(); // Assuming the API returns JSON
        })
        .then(data => setReplays(data))
        .catch(err => {
            setError(err.message);
        });
    }, []);

  return (
    <Container className="brand-page mt-5">
      <h1>LiveTV Streaming</h1>
      <p>Welcome to the LiveTV Streaming Page! Here you can find sports streaming events.</p>

      {/* Display error if fetching fails */}
      {error && <Alert variant="danger">Error: {error}</Alert>}

      {/* Search box to filter LiveTV events */}
      {replays.length > 0 && (
        <EventSearchBox value={searchQuery} onChange={setSearchQuery} />
      )}

      {/* Display table of LiveTV */}
      {visibleReplays.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Time</th>
              <th>Description</th>
              <th>Link</th>
            </tr>
          </thead>
          <tbody>
            {visibleReplays.map((replay, index) => {
              // Make sure to remove any leading slashes from the link
              const cleanLink = replay.link.replace(/^\/+/, '');
              
              return (
                <tr key={index}>
                  <td>{replay.time}</td>
                  <td>{replay.description}</td>
                  <td>
                    <a href={`/streaming/livetv/event/${encodeURIComponent(cleanLink)}`} rel="noopener noreferrer">
                      Watch
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p>
          {searchQuery
            ? 'No events match your search.'
            : 'No replays available.'}
        </p>
      )}
    </Container>
  );
}

export default LiveTvPage;
